import { http } from 'viem';

import { getChain } from 'modules/api/utils/getChain';

export function getCreateWalletClientParams() {
  return {
    chain: getChain(),
    transport: http(),
  };
}
